import { ApiService } from "@core/api/api-service";
import { addBaseUrlInterceptor } from "@core/api/interceptors/add-base-url-interceptor";
import { errorHandlingInterceptor } from "@core/api/interceptors/error-handling-interceptor";
import { addRequestInterceptor, addResponseInterceptor } from "@core/api/interceptors/interceptor";
import { InfraManager } from "@domain/infra/infra-manager";
import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";

export class UnauthenticatedApiService implements ApiService {
	axiosInstance: AxiosInstance;

	constructor(
		private readonly axiosInstanceProvider: () => AxiosInstance,
		private readonly infraManager: InfraManager,
	) {
		this.axiosInstance = this.initiateAxiosInstance();
		infraManager.targetInfraChanged.add(this.refreshAxiosInstance.bind(this));
	}

	private refreshAxiosInstance(): void {
		this.axiosInstance = this.initiateAxiosInstance();
	}

	private initiateAxiosInstance(): AxiosInstance {
		const axiosInstance = this.axiosInstanceProvider();
		addRequestInterceptor(axiosInstance, addBaseUrlInterceptor(this.infraManager));

		addResponseInterceptor(axiosInstance, errorHandlingInterceptor());

		return axiosInstance;
	}

	get<T = unknown, R = AxiosResponse<T>>(url: string, config?: AxiosRequestConfig): Promise<R> {
		return this.axiosInstance.get(url, config);
	}

	post<T = unknown, R = AxiosResponse<T>>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<R> {
		return this.axiosInstance.post(url, data, config);
	}

	put<T = unknown, R = AxiosResponse<T>>(url: string, data?: unknown, config?: AxiosRequestConfig): Promise<R> {
		return this.axiosInstance.put(url, data, config);
	}

	delete<T = unknown, R = AxiosResponse<T>>(url: string, config?: AxiosRequestConfig): Promise<R> {
		return this.axiosInstance.delete(url, config);
	}
}
